<div class="gemini-pro-dialog">
  <button class="close-btn" (click)="close()" aria-label="Close dialog">×</button>

  <div class="header">
    <img src="assets/logos/google.svg" alt="Gemini Pro Logo" class="logo" />
    <h2>Gemini Pro</h2>
    <div class="sub">Google’s High-Speed, Multimodal Intelligence Engine</div>
  </div>

  <div class="body">
    <p>
      <strong>Gemini Pro</strong> is optimized for speed, scale, and real-world knowledge integration.
      Built on Google’s infrastructure, it excels at fast reasoning, search-adjacent intelligence,
      and seamless handling of multimodal inputs like text and images (where enabled).
      It’s designed to feel lightweight, responsive, and immediately useful.
    </p>

    <ul>
      <li>Ultra-fast responses tuned for real-time interaction and high throughput</li>
      <li>Strong general reasoning grounded in broad, web-scale knowledge</li>
      <li>Native strength in search-style queries, summaries, and factual synthesis</li>
      <li>Multimodal understanding across text, images, and structured prompts*</li>
      <li>Deep integration potential with Google’s ecosystem and developer tooling</li>
    </ul>

    <div class="optimal">
      <h3>Reasoning controls</h3>
      <ul>
        <li><strong>Auto / Instant:</strong> minimal reasoning for speed.</li>
        <li><strong>Thinking:</strong> medium-depth reasoning for analysis.</li>
        <li><strong>Pro:</strong> high-depth reasoning for complex tasks.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Best Used For:</h3>
      <ul>
        <li>Search-like Q&A, rapid research, and fact-oriented exploration</li>
        <li>Summarization of articles, documents, and mixed-content inputs</li>
        <li>Brainstorming, outlining, and early-stage ideation at high speed</li>
        <li>Code assistance, explanations, and lightweight debugging</li>
        <li>Scalable applications needing fast, reliable, Google-backed AI responses</li>
      </ul>
    </div>

    <div class="note">
      <strong>*Note:</strong> Multimodal and image capabilities depend on API tier,
      model configuration, and integration environment.
    </div>
  </div>
</div>
